module.exports = __webpack_public_path__ + "img/shield_done.882a010c.svg";